import { CdrLink as m } from "@rei/cedar";
import { resolveComponent as S, openBlock as d, createElementBlock as f, createElementVNode as k, normalizeClass as v, Fragment as w, renderList as p, createVNode as y, withModifiers as b, withCtx as I, createTextVNode as T, toDisplayString as L } from "vue";
const C = (t, s) => {
  const e = t.__vccOpts || t;
  for (const [o, n] of s)
    e[o] = n;
  return e;
}, A = {
  /* c8 ignore start */
  name: "StickySubnav",
  components: {
    CdrLink: m
  },
  props: {
    navItems: {
      type: Array,
      required: !0,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      isSticky: !1,
      navHeight: 0,
      allowChangingActiveItem: !0,
      distance: 0,
      showGradients: {
        right: 0,
        left: 0
      },
      scrollTimeout: !0,
      scrollPos: 0
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.onResize), this.$refs.track.addEventListener("scroll", this.handleGradients), this.setNavHeight(), this.handleGradients(), this.handleNavSticking(), this.handleActiveStatusOnScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.onResize), this.$refs.track.removeEventListener("scroll", this.handleGradients);
  },
  methods: {
    onScroll() {
      this.onScrollDone(), this.scrollTimeout && (this.scrollTimeout = !1, setTimeout(() => {
        this.scrollTimeout = !0;
        const {
          pageYOffset: t
        } = window, {
          documentElement: s
        } = document, {
          scrollTop: e,
          clientTop: o
        } = s;
        this.scrollPos = Math.round((t || e) - (o || 0)), this.handleNavSticking(), this.allowChangingActiveItem && this.handleActiveStatusOnScroll();
      }, 66));
    },
    onResize() {
      this.setNavHeight();
    },
    linkClick(t, s) {
      this.handleActiveStatusOnClick(t, s), this.scrollToSection(t.anchor);
    },
    handleGradients() {
      const {
        track: t,
        container: s
      } = this.$refs, e = t.scrollWidth, o = s.offsetWidth - 24 * 2, n = Math.round(t.scrollLeft);
      this.showGradients.left = n > 0, this.showGradients.right = n < e - o;
    },
    setNavHeight() {
      const {
        offsetHeight: t
      } = this.$refs.container;
      this.navHeight = t, this.$el.style.height = `${t}px`;
    },
    handleNavSticking() {
      const {
        offsetTop: t
      } = this.$el;
      this.isSticky = this.scrollPos >= t;
    },
    handleActiveStatusOnScroll() {
      const {
        navHeight: t,
        scrollPos: s,
        handleOverflowedActiveItem: e,
        activeIndex: o,
        navItems: n
      } = this;
      n.forEach((r, c) => {
        const i = r.anchor && document.querySelector(`#${r.anchor}`);
        if (!i)
          return;
        const {
          offsetTop: l,
          offsetHeight: a
        } = i, h = s + t + 32, _ = l + a - t, u = l <= h, g = _ < s;
        u && !g && c !== o ? (this.activeIndex = c, e(r.anchor)) : !u && !g && c === o && (this.activeIndex = c > 0 ? c - 1 : 0, e(r.anchor));
      });
    },
    handleOverflowedActiveItem(t) {
      const s = this.$refs[t][0], {
        track: e
      } = this.$refs, {
        showGradients: {
          right: o,
          left: n
        }
      } = this, {
        right: r,
        left: c
      } = (s == null ? void 0 : s.getBoundingClientRect()) || {}, {
        right: i,
        left: l
      } = (e == null ? void 0 : e.getBoundingClientRect()) || {}, a = o ? 40 : 0, h = n ? 40 : 0;
      r > i - a ? e.scrollLeft = e.scrollLeft + r - i + a : c < l + h && (e.scrollLeft = e.scrollLeft - (l - c) - h);
    },
    handleActiveStatusOnClick(t, s) {
      this.activeIndex = s, this.handleOverflowedActiveItem(t.anchor);
    },
    scrollToSection(t) {
      const {
        isSticky: s,
        navHeight: e,
        setFocus: o
      } = this;
      this.allowChangingActiveItem = !1;
      const n = document.getElementById(t), {
        offsetTop: r
      } = n, c = s ? e : this.$el.offsetHeight, i = Math.floor(r - c);
      this.distance = i, o(n), window.scrollTo({
        top: this.distance,
        behavior: "smooth"
      });
    },
    onScrollDone() {
      this.scrollPos === this.distance && (this.allowChangingActiveItem = !0);
    },
    setFocus(t) {
      !t || document.activeElement === t || (t.tabIndex = "-1", t.focus({
        preventScroll: !0
      }));
    }
  }
  /* c8 ignore end */
}, E = {
  "aria-label": "Page navigation",
  class: "sticky-subnav"
}, x = ["aria-current", "data-ui"];
function H(t, s, e, o, n, r) {
  const c = S("cdr-link");
  return d(), f("nav", E, [k("div", {
    ref: "container",
    class: v(["sticky-subnav__inner", {
      "sticky-subnav__inner--sticky": n.isSticky
    }])
  }, [k("ul", {
    ref: "track",
    class: v(["sticky-subnav__track", {
      "sticky-subnav__track--overflow-right": n.showGradients.right
    }, {
      "sticky-subnav__track--overflow-left": n.showGradients.left
    }])
  }, [(d(!0), f(w, null, p(e.navItems, (i, l) => (d(), f("li", {
    ref_for: !0,
    ref: i.anchor,
    key: i.text,
    "aria-current": l === n.activeIndex,
    class: v(["sticky-subnav__link-container", {
      "sticky-subnav__link-container--active": l === n.activeIndex
    }]),
    "data-ui": i.anchor
  }, [y(c, {
    href: `#${i.anchor}`,
    class: "sticky-subnav__link",
    "aria-label": i.ariaLabel,
    onClick: b((a) => r.linkClick(i, l), ["prevent"])
  }, {
    default: I(() => [T(L(i.text), 1)]),
    _: 2
  }, 1032, ["href", "aria-label", "onClick"])], 10, x))), 128))], 2)], 2)]);
}
const O = /* @__PURE__ */ C(A, [["render", H]]);
export {
  O as default
};
